import { render } from "./ChatWindow.vue?vue&type=template&id=ae2f4c82"
import script from "./ChatWindow.vue?vue&type=script&lang=js"
export * from "./ChatWindow.vue?vue&type=script&lang=js"

import "./ChatWindow.vue?vue&type=style&index=0&id=ae2f4c82&lang=css"

import exportComponent from "C:\\Users\\marti\\Documents\\dev\\JavaScript\\live-chat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__